import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=1b6c4ce2&scoped=true&"
import script from "./labelmanagement.js?vue&type=script&lang=js&"
export * from "./labelmanagement.js?vue&type=script&lang=js&"
import style0 from "./LabelManagement.vue?vue&type=style&index=0&id=1b6c4ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c4ce2",
  null
  
)

export default component.exports